import { FC } from 'react';
import { Text, Flex, FlexProps } from '@chakra-ui/react';
export interface CbEmptyCardProps extends FlexProps {
  msg: string;
}
export const CbEmptyCard: FC<CbEmptyCardProps> = ({
  msg,
  children,
  ...props
}) => {
  return <Flex borderRadius="16px" backgroundColor="cloud.100" flex={1} justifyContent="center" alignItems="center" paddingY={10} paddingX={4} {...props} data-sentry-element="Flex" data-sentry-component="CbEmptyCard" data-sentry-source-file="CbEmptyCard.tsx">
      <Text fontWeight="bold" color="cloud.600" data-sentry-element="Text" data-sentry-source-file="CbEmptyCard.tsx">
        {msg}
      </Text>
      {children}
    </Flex>;
};